module.exports = __webpack_public_path__ + "media/images/beach-cd55203f.png";